import { Hero } from "@/components/sections/Hero";
import { TrustMarquee } from "@/components/sections/TrustMarquee";
import { ProductShowcase } from "@/components/sections/ProductShowcase";
import { Manifesto } from "@/components/sections/Manifesto";
import { StatsBand } from "@/components/sections/StatsBand";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { Testimonials } from "@/components/sections/Testimonials";
import { PricingSection } from "@/components/sections/PricingSection";
import { FaqSection } from "@/components/sections/FaqSection";
import { CtaBanner } from "@/components/sections/CtaBanner";
import { useProducts } from "@/hooks/useProducts";

export default function Home() {
  const { data: products = [] } = useProducts();
  return (
    <div data-testid="home-page">
      <Hero />
      <TrustMarquee />
      <ProductShowcase products={products} />
      <Manifesto />
      <StatsBand />
      <HowItWorks />
      <Testimonials limit={6} />
      <PricingSection />
      <FaqSection limit={6} />
      <CtaBanner />
    </div>
  );
}
